<div class="main-search">
  <orbit-input
    class="search"
    [placeholder]="'SHARED.CONVERSATION_LIST_SEARCH_BAR.INPUT_PLACEHOLDER' | translate"
    [controller]="filterInputController()"
    [large]="true"
    [addonRight]="{ icon: searchIcon }" />
  <orbit-fa-icon
    [ngClass]="{
      'filter-active': showFilters,
    }"
    class="filter"
    [iconName]="filterIcon"
    (click)="showFilters = !showFilters" />
</div>
@if (showFilters) {
  <div class="extended-search">
    <orbit-checkbox
      [name]="'archived'"
      [controller]="showArchivedController()"
      [id]="'archived'"
      [label]="'SHARED.CONVERSATION_LIST_SEARCH_BAR.ARCHIVED_FILTER_LABEL' | translate" />
  </div>
}
